import styled from 'styled-components';
import { LinkBadgeType } from '../VerticalNav/hooks/useLinkBadgeData';
import { UpgradeArrow } from 'breadcrumbs-ui/icons';
import Popover from '../Popover';
import LinkBadgeTooltip from './LinkBadgeTooltip';
// TODO Do not bundle `foundations-components` in the navigation bundle
// eslint-disable-next-line no-restricted-imports
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledLinkBadgeDiv = styled.div.withConfig({
  displayName: "LinkBadge__StyledLinkBadgeDiv",
  componentId: "byrp7k-0"
})(["display:inline-flex !important;align-self:center;"]);
const LinkBadge = ({
  type,
  text,
  tooltipText = '',
  tooltipPlacement = 'right',
  tooltipTarget,
  tooltipPadding,
  isHovering = false,
  tooltipId
}) => {
  const badgeStyling = type === LinkBadgeType.comingSoon || type === LinkBadgeType.beta ? 'beta' : 'new';
  return /*#__PURE__*/_jsx(Popover, {
    isOpen: !!tooltipText && isHovering,
    placement: tooltipPlacement,
    target: tooltipTarget,
    content: /*#__PURE__*/_jsx(LinkBadgeTooltip, {
      id: tooltipId,
      text: tooltipText
    }),
    padding: tooltipPadding,
    children: /*#__PURE__*/_jsxs(StyledLinkBadgeDiv, {
      children: [type === LinkBadgeType.comingSoon || type === LinkBadgeType.beta || type === LinkBadgeType.new ? /*#__PURE__*/_jsx(Badge, {
        use: badgeStyling,
        children: text
      }) : null, type === LinkBadgeType.upgradeArrow ? /*#__PURE__*/_jsx(UpgradeArrow, {}) : null]
    })
  });
};
export default LinkBadge;